import {Injectable} from '@angular/core';

/**
 * Translations for delivery methods.
 */
@Injectable()
export class DeliveryMethodTranslationService {
  public i18nMailing: any = $localize`:@@general.text.mailing:Mailing`;
  public i18nPrintHome: any = $localize`:@@general.text.printHome:print@home`;
  public i18nDigitalTicket: any = $localize`:@@general.text.digitalTicket:Digital ticket`;
  constructor() { }
}
